import { CError } from '../consoleMixin'
import { getAxiosClient } from './axios-client'

/**
 * @typedef {import('./js-doc').V2CreateEmployeeRequest} V2CreateEmployeeRequest
 * @typedef {import('./js-doc').V2CreateEmployeeResponse} V2CreateEmployeeResponse
 * @typedef {import('./js-doc').V1Employee} V1Employee
 */

export class EmployeeV2 {
  constructor() {
    this.baseURL = 'employees'
  }

  /**
   * Create an employee
   * @param {V2CreateEmployeeRequest} payload 
   * @returns {Promise<V2CreateEmployeeResponse>}
   */
  async create(payload) {
    try {
      const result = await (await getAxiosClient(this.baseURL)).post('', payload)
      return result?.data
    } catch (error) {
      CError(`Could not create employee in V2 API`, error)
      throw error
    }
  }
}

export default EmployeeV2
